import { useState } from 'react';
import { MicVocal, User as UserIcon, ChevronDown, LogOut } from 'lucide-react';

const Header = ({ onGetStarted, user, onLogout, onLoginClick, onProfileClick }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-slate-900 border-b border-slate-700 sticky top-0 z-50">
      <nav className="container mx-auto px-6 py-4 flex items-center justify-between">
        {/* Logo */}
        <a href="/" className="flex items-center space-x-2 group">
          <div className="bg-emerald-500 p-2 rounded-lg group-hover:bg-emerald-600 transition-colors">
            <MicVocal className="w-6 h-6 text-white" />
          </div>
          <span className="text-2xl font-bold text-white tracking-tight">Scribify</span>
        </a>

        {user ? (
          <div className="relative">
            {/* Bouton Pseudo avec Dropdown */}
            <button 
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="flex items-center space-x-3 bg-slate-800 border border-slate-700 hover:border-emerald-500/50 px-4 py-2 rounded-full transition-all"
            >
              <div className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"></div>
              <span className="text-slate-200 font-medium">{user.username}</span>
              <ChevronDown className={`w-4 h-4 text-slate-400 transition-transform ${isMenuOpen ? 'rotate-180' : ''}`} />
            </button>

            {/* Menu Déroulant */}
            {isMenuOpen && (
              <>
                {/* Overlay pour fermer le menu en cliquant ailleurs */}
                <div className="fixed inset-0 z-10" onClick={() => setIsMenuOpen(false)}></div>
                
                <div className="absolute right-0 mt-2 w-56 bg-slate-800 border border-slate-700 rounded-xl shadow-2xl z-20 overflow-hidden animate-in fade-in zoom-in-95 duration-100">
                  <div className="p-3 border-b border-slate-700 bg-slate-800/50">
                    <p className="text-xs text-slate-500 font-semibold uppercase tracking-wider">My Account</p>
                    <p className="text-sm text-slate-300 truncate">{user.email}</p>
                  </div>
                  
                  <div className="p-1">
                    <button 
                      onClick={() => { onProfileClick(); setIsMenuOpen(false); }}
                      className="w-full flex items-center space-x-3 px-3 py-2.5 text-slate-300 hover:bg-slate-700 hover:text-white rounded-lg transition-colors"
                    >
                      <UserIcon className="w-4 h-4" />
                      <span className="text-sm font-medium">My Profile</span>
                    </button>
                    
                    <button 
                      onClick={() => { onLogout(); setIsMenuOpen(false); }}
                      className="w-full flex items-center space-x-3 px-3 py-2.5 text-rose-400 hover:bg-rose-500/10 rounded-lg transition-colors"
                    >
                      <LogOut className="w-4 h-4" />
                      <span className="text-sm font-medium">Log out</span>
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        ) : (
          <div className="flex items-center space-x-6">
            <button onClick={onLoginClick} className="text-slate-300 hover:text-white font-medium">Login</button>
            <button onClick={onGetStarted} className="px-6 py-2 bg-emerald-600 hover:bg-emerald-500 text-white font-semibold rounded-lg transition-all shadow-lg shadow-emerald-500/20">
              Get Started
            </button>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;